import { IDeviceMessages } from "@types"
import { protectedApi } from "store/Api"

const deviceMessagesApi = protectedApi.injectEndpoints({

    endpoints: (builder) => ({
        fetchDeviceMessages: builder.query<IDeviceMessages[], void>({
            query: () => {
                return {
                    method: "GET",
                    url: `devices/messages`,
                }
            },
        }),
    }),
})

export const { useFetchDeviceMessagesQuery } = deviceMessagesApi
